import { Controller } from "@hotwired/stimulus"
import confetti from "canvas-confetti"

export default class extends Controller {
    static values = { confetted: Boolean }

    connect() {
        if (!this.hasConfetted()) {
            this.confetti()
        }
    }

    confetti() {
        this.fire()
        this.markAsConfetted()
    }

    fire() {
        confetti({
            zIndex: 2000,
            particleCount: 250,
            spread: 180,
            disableForReducedMotion: true,
            // shapes: ['star'],
        })

    }

    hasConfetted() {
        return this.confettedValue
    }

    markAsConfetted() {
        this.confettedValue = true
    }
}
